export const EUR_CONVERSION = 7.53450;
